<!--
 * @Author: 田鑫
 * @Date: 2021-10-20 13:25:53
 * @LastEditors: 田鑫
 * @LastEditTime: 2022-01-05 10:28:38
 * @Description: 用户管理
-->
<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>门诊预约问诊管理</el-breadcrumb-item>
        <el-breadcrumb-item>用户管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <el-form ref="listForm" :model="listParams" label-width="120px" inline>
        <!-- <el-form-item label="手机号：" prop="mobile">
          <el-input
            maxlength="11"
            v-model="listParams.mobile"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item> -->

        <el-form-item label="问诊账号：" prop="account">
          <el-input v-model="listParams.account" placeholder="请输入问诊账号"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button size="small" type="primary" @click="loadTableData"> 查询 </el-button>
        </el-form-item>
      </el-form>

      <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
        <div slot="action"></div>

        <hx-table-result-col>
          <div class="wrap-table-info-display">
            <el-button @click="addUser" type="primary">新建用户</el-button>
            <span class="table-info-display">
              <span>总条数：</span>
              <span class="alert-text ft16">{{ pager.total }}</span>
            </span>
          </div>
        </hx-table-result-col>

        <el-table slot="content" :data="tableData" max-height="600" border>
          <el-table-column fixed align="center" width="60" label="序号">
            <template slot-scope="scope">
              <span v-text="(pager.pageIndex > 1 ? (pager.pageIndex - 1) * pager.pageSize : 0) + scope.$index + 1"> </span>
            </template>
          </el-table-column>

          <!-- <el-table-column
            label="用户手机号"
            prop="userMobile"
            align="center"
          ></el-table-column> -->
          <el-table-column label="问诊账号" prop="account" align="center"></el-table-column>
          <el-table-column label="添加时间" prop="createdTime" align="center">
            <template slot-scope="scope">
              {{ scope.row.createdTime | formatDate(true) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" prop="" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="editItem(scope.row.id)">修改密码</el-button>
              <confirm-button type="text" style="margin: 0 10px" title="确认要删除该条数据？" @confirmed="deleteItem(scope.row.id)">
                <span>删除</span>
              </confirm-button>
            </template>
          </el-table-column>
        </el-table>
      </hx-table-result>
    </div>

    <el-dialog title="新建用户" :visible.sync="dialogVisible" @close="$refs['dialogForm'].resetFields()">
      <el-form ref="dialogForm" :model="dialogForm" :rules="dialogRules" label-width="140px">
        <!-- <el-form-item label="用户手机号：" prop="userMobile">
          <el-input
            :disabled="isEdit"
            maxlength="11"
            v-model="dialogForm.userMobile"
            placeholder="请填写用户手机号"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="预约/问诊账号：" prop="account">
          <el-input :disabled="isEdit" v-model="dialogForm.account" placeholder="请填写预约/问诊账号"></el-input>
        </el-form-item>
        <el-form-item label="预约/问诊密码：" prop="password" v-if="isEdit">
          <el-input v-model="dialogForm.password" placeholder="请填写预约/问诊密码"></el-input>
        </el-form-item>
        <el-form-item label="" prop="">
          <div style="align: right">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button @click="saveForm('dialogForm')" type="primary" :disabled="isDisabled">保存</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listParams: {
        mobile: "",
        account: "",
      },
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      tableLoading: false,
      tableData: [],
      dialogVisible: false,
      dialogForm: {
        // userMobile: "",
        account: "",
        // password: "",
      },
      dialogRules: {
        // userMobile: [
        //   { required: true, message: "请填写用户手机号", trigger: "blur" },
        // ],
        account: [{ required: true, message: "请填写预约/问诊账号", trigger: "blur" }],
        // password: [
        //   { required: true, message: "请填写预约/问诊密码", trigger: "blur" },
        // ],
      },
      isDisabled: false,
      isEdit: false,
    };
  },
  mounted() {
    this.loadTableData();
  },
  methods: {
    loadTableData() {
      this.tableLoading = true;
      const bodyParams = Object.assign(this.listParams, this.pager);
      this.$http({
        url: global.apiUrl + "/medical/user/list",
        method: "GET",
        params: bodyParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableData = res.body.data.dataList;
            this.pager.total = res.body.data.total;
          }
          this.tableLoading = false;
        })
        .catch(err => {
          this.tableLoading = false;
          console.error(err);
        });
    },
    resetForm(name) {
      this.$refs[name].resetFields();
      this.loadTableData();
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
    /**
     * @description: 新增用户
     * @param {*}
     * @return {*}
     */
    addUser() {
      this.isEdit = false;
      this.dialogVisible = true;
    },
    /**
     * @description: 编辑用户
     * @param {*} id
     * @return {*}
     */
    editItem(id) {
      this.$http({
        url: global.apiUrl + `/medical/user/detail?id=${id}`,
        method: "GET",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            Object.assign(this.dialogForm, res.body.data);
            this.isEdit = true;
            this.dialogVisible = true;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    deleteItem(id) {
      this.$http
        .delete(global.apiUrl + `/medical/user/delete?id=${id}`)
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.loadTableData();
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    saveForm(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.isDisabled = true;
          let url = "";
          let method = "";
          if (this.isEdit) {
            url += global.apiUrl + "/medical/user/edit";
            method += "PUT";
          } else {
            url += global.apiUrl + "/medical/user/save";
            method += "POST";
          }
          this.$http({
            url: url,
            method: method,
            body: this.dialogForm,
          })
            .then(res => {
              if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
                this.dialogVisible = false;
                this.isDisabled = false;
                this.dialogForm = this.$options.data().dialogForm;
                this.loadTableData();
              } else {
                this.isDisabled = false;
              }
            })
            .catch(err => {
              console.error(err);
              this.isDisabled = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped></style>
